import { t } from "i18next";
import {
    setDataIsUpdated,
    setEditedDataLogo,
    setInputImageUploader,
    setIsEdited,
    setIsLoading,
    setIsValidateClicked,
    setKey,
    setLogoData,
    setNumberActive,
    setNumberArchived,
} from "../store";
import ErrorToast, { WarnToast } from "@components/Common/ErrorTost";
import { ShowSuccessToast } from "@pages/SettingGeneral/Language/ShowSuccessToast";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { getSalesSupportUpdated } from "./LogoForm";
import { uuid } from "uuidv4";
import { extractUniqueIds } from "@pages/SettingGeneral/ModeOfSale/ModeOfSales/hooks";

export async function handleStateChange(
    dataState: boolean,
    selectedRowData: any,
    logoData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    choiceState: any,
    fetchGlobal: any
) {
    try {
        let updatedLogo: any = {};
        let id = selectedRowData?.selectedRow.Id;

        logoData.forEach((logo: any) => {
            if (id === logo.Id) {
                Object.assign(updatedLogo, {
                    [id]: {
                        designation:
                            selectedRowData?.selectedRow[t("Designation")],
                        tag: selectedRowData?.selectedRow.tag,
                        shopId: selectedRowData?.selectedRow.shopId,
                        isArchived: selectedRowData?.selectedRow.isArchived,
                        isActive: dataState,
                        support_de_vente:
                            selectedRowData.selectedRow[t("Sales support")],
                        urlImage: selectedRowData.selectedRow[t("Image")],
                        img: selectedRowData?.selectedRow.img,
                    },
                });
            } else if (dataState === true && logo.isActive === true) {
                Object.assign(updatedLogo, {
                    [logo.Id]: {
                        designation: logo[t("Designation")],
                        tag: logo.tag,
                        shopId: logo.shopId,
                        isArchived: logo.isArchived,
                        isActive: false,
                        support_de_vente: logo[t("Sales support")],
                        urlImage: logo[t("Image")],
                        img: logo.img,
                    },
                });
            }
        });
        let dataLogo = {
            userId: userID,
            shopId: [selectedRowData?.selectedRow.shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: updatedLogo,
        };
        const isStateChange = dataState;
        const data = new FormData();
        data.append("dataLogo", JSON.stringify({ dataLogo, isStateChange }));
        data.append("image", "");
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
        const requestOptions = {
            method: "POST",
            body: data,
        };

        const result = await fetchGlobal(apiUrl, requestOptions);

        if (result.error) {
            throw Error(result.message);
        }
        ShowSuccessToast(
            !choiceState
                ? `${t("logo has been successfully activated")}`
                : `${t("logo has been successfully deactivated")}`
        );
        setIsLoading(false);
    } catch (error: any) {
        ErrorToast(`${error}`);
        setIsLoading(false);
    }
}

export async function archiveLogo(
    element: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    numberArchived: any,
    numberActive: any,
    setIsClicked: any,
    fetchGlobal: any
) {
    setIsClicked(false);
    let dataLogo = {
        userId: userID,
        shopId: [element.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: {
            [element.Id]: {
                designation: element[t("Designation")],
                support_de_vente: element[t("Sales support")],
                urlImage: element[t("Image")],
                shopId: element.shopId,
                img: element.img,
                tag: element.tag,
                isActive: false,
                isArchived: true,
            },
        },
    };

    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    const requestOptions = {
        method: "POST",
        body: data,
    };
    try {
        const data = await fetchGlobal(apiUrl, requestOptions);
        if (data.error) {
            throw Error("error");
        }

        ShowSuccessToast(`${t("The logo is successfully archived")!}`);

        setIsLoading(false);
        setDataIsUpdated(true);
        setNumberActive(numberActive - 1);
        setNumberArchived(numberArchived + 1);
        setIsClicked(true);
        setKey(uuid());
    } catch (e: any) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function activeLogo(
    selectedRowData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    oneShop: any,
    setDataIsUpdated: any,
    setIsClicked: any,
    numberActive: any,
    numberArchived: any,
    fetchGlobal: any
) {
    setIsClicked(false);
    let dataLogo = {
        userId: userID,
        shopId: [selectedRowData.selectedRow.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,

        data: {
            [selectedRowData.selectedRow.Id]: {
                designation: selectedRowData?.selectedRow[t("Designation")],
                tag: selectedRowData?.selectedRow.tag,
                shopId: selectedRowData?.selectedRow.shopId,

                isActive: oneShop ? false : true,
                support_de_vente:
                    selectedRowData.selectedRow[t("Sales support")],
                urlImage: selectedRowData.selectedRow[t("Image")],
                img: selectedRowData.selectedRow.img,
                isArchived: false,
            },
        },
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    const requestOptions = {
        method: "POST",
        body: data,
    };
    try {
        const data = await fetchGlobal(apiUrl, requestOptions);
        if (data.error) {
            throw Error("error");
        }
        ShowSuccessToast(`${t("logo has been successfully activated")!}`);
        setIsLoading(false);
        setDataIsUpdated(true);
        setNumberActive(numberActive + 1);
        setNumberArchived(numberArchived - 1);
        setIsClicked(true);
        setKey(uuid());
    } catch (e: any) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function isSaleSupportArchived(
    selectedRowData: any,
    userID: any,
    shopId: any,
    franchiseID: any,
    fetchGlobal: any
) {
    let isSaleSupportArchived = false;
    try {
        const i18nextLng = localStorage.getItem("i18nextLng") || "fr";

        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;
        const data = await fetchGlobal(url, {
            method: "GET",
            headers: { "Accept-Language": i18nextLng },
        });
        data.data.forEach((elt: any) => {
            if (
                selectedRowData.selectedRow[t("Sales support")]
                    .split(",")
                    .includes(elt[t("Sale support")])
            ) {
                isSaleSupportArchived = true;
            }
        });
    } catch (error) {
        ErrorToast(`${error}`);
    }
    return isSaleSupportArchived;
}

export async function handleArchiveLogo(
    selectedRows: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: any
) {
    try {
        let dataLogolocal: any = {};
        let shopIds: any = [];
        selectedRows.forEach(async (el: any) => {
            const id = el.Id;
            const normalizedShopId = el.shopId === 0 ? "0" : el.shopId;

            if (!shopIds.includes(normalizedShopId)) {
                shopIds.push(normalizedShopId);
            }

            dataLogolocal[id] = {
                designation: el[t("Designation")],
                support_de_vente: el[t("Sales support")],
                urlImage: el[t("Image")],
                shopId: el.shopId,
                tag: el.tag,
                isActive: false,
                img: el.img,
                isArchived: true,
            };
        });

        let dataLogo = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: dataLogolocal,
        };
        const data = new FormData();
        data.append("dataLogo", JSON.stringify(dataLogo));
        data.append("image", "");
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;

        const result = await fetchGlobal(apiUrlAdd, {
            method: "POST",
            body: data,
        });
        if (result.error === false) {
            ShowSuccessToast(`${t("The logo is successfully archived")!}`);
            setIsLoading(false);
            setKey(uuid());
        }
    } catch (error) {
        ErrorToast(`${error}`);
        setIsLoading(false);
    }
}
export async function handleActiveLogo(
    selectedRows: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: any
) {
    try {
        let dataLogolocal: any = {};
        let shopIds: any = [];
        selectedRows.forEach(async (el: any) => {
            const id = el.Id;
            const normalizedShopId = el.shopId === 0 ? "0" : el.shopId;

            if (!shopIds.includes(normalizedShopId)) {
                shopIds.push(normalizedShopId);
            }
            dataLogolocal[id] = {
                designation: el[t("Designation")],
                support_de_vente: el[t("Sales support")],
                urlImage: el[t("Image")],
                shopId: el.shopId,
                tag: el.tag,
                img: el.img,
                isActive: false,
                isArchived: false,
            };
        });

        let dataLogo = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: dataLogolocal,
        };
        const data = new FormData();
        data.append("dataLogo", JSON.stringify(dataLogo));
        data.append("image", "");
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;

        await fetchGlobal(apiUrlAdd, {
            method: "POST",
            body: data,
        });

        ShowSuccessToast(`${t("logo has been successfully activated")!}`);
        setIsLoading(false);
        setKey(uuid());
    } catch (error) {
        ErrorToast(`${error}`);
        setIsLoading(false);
    }
}

export async function editLogo(
    associated: any,
    editedDataLogo: any,
    salesSupport: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    rowData: any,
    isSalesSupportEmpty: any[],
    isDataChanged: boolean,
    isAddLogoClicked: boolean,
    setIsAddLogoClicked: any,
    setIsDataUpdatedShops: any,
    uploadedImage: any,
    fetchGlobal: any
) {
    try {
        setIsLoading(true);

        let updatedData: any = {};
        let successFlag = false;
        let dataLogo: any = [];
        let objectData: any = {};
        let shopIds: any = [];

        for (const el of associated) {
            const id = el.Id;

            if (!shopIds.includes(el.shopId)) {
                shopIds.push(el.shopId);
            }

            if (!objectData[el.shopId]) {
                objectData[el.shopId] = {};
            }

            objectData[el.shopId][id] = {
                designation: editedDataLogo.data[id].designation,
                tag: editedDataLogo.data[id].tag,
                support_de_vente: salesSupport,
                isArchived: el.isArchived,
                shopId: el.shopId,
                isActive: el.isActive,
                urlImage: editedDataLogo.data[id].urlImage,
                img: editedDataLogo.data[id].img,
            };

            const oldData = {
                designation: rowData[t("Designation")],
                support_de_vente: rowData[t("Sales support")],
                urlImage: rowData.Image,
            };

            if (
                rowData[t("Sales support")].includes("KIOSK") ||
                editedDataLogo.data[id].support_de_vente.includes("KIOSK")
            ) {
                updatedData = getSalesSupportUpdated(
                    oldData,
                    {
                        designation: editedDataLogo.data[id].designation,
                        support_de_vente: salesSupport,
                        urlImage: editedDataLogo.data[id].urlImage,
                    },
                    "KIOSK",
                    "support_de_vente"
                );
            }
        }

        dataLogo = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: objectData,
        };

        const formData = new FormData();
        formData.append("dataLogo", JSON.stringify({ dataLogo, updatedData }));
        formData.append("image", uploadedImage);
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo/update`;
        try {
            const result = await fetchGlobal(apiUrlAdd, {
                method: "PUT",
                body: formData,
            });

            if (result.error) throw new Error("API error");

            if (!isSalesSupportEmpty.includes(false)) {
                successFlag = true;
            } else if (
                (isSalesSupportEmpty.includes(true) &&
                    isSalesSupportEmpty.includes(false)) ||
                (!isSalesSupportEmpty.includes(true) && isDataChanged)
            ) {
                WarnToast(
                    t(
                        "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                    )
                );
                successFlag = true;
            } else if (!isSalesSupportEmpty.includes(true) && !isDataChanged) {
                WarnToast(
                    t(
                        "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                    )
                );
                setIsLoading(false);
                setIsAddLogoClicked(!isAddLogoClicked);
                setKey(uuid());
            }
        } catch (err) {
            setIsLoading(false);
            ErrorToast(`${err}`);
            return;
        }

        if (successFlag) {
            setIsLoading(false);
            setKey(uuid());
            ShowSuccessToast(
                t("The logo of the store(s) has been changed successfully")
            );
            setDataIsUpdated(true);
            setIsAddLogoClicked(!isAddLogoClicked);
            setIsDataUpdatedShops(true);
            setIsValidateClicked(true);
            setIsEdited(false);
        }
    } catch (error) {
        setIsLoading(false);
        throw error;
    }
}

export async function AssociateLogo(
    dataFranchiseLogo: any,
    designation: any,
    userID: any,
    shopID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    salesSupport: any,
    setIsDataUpdatedShops: any,
    resetAllPeripherals: any,
    setDesignation: any,
    setSalesSupport: any,
    setUploadedImage: any,
    numberActive: any,
    setLocalFilterActive: any,
    clearData: any,
    clearMultiCustomSelectionData: any,
    fetchGlobal: any
) {
    setIsValidateClicked(false);
    let objectData =
        dataFranchiseLogo[
            dataFranchiseLogo.findIndex(
                (el: any) => el[t("Designation")] === designation
            )
        ];

    let dataLogo = {
        affectation: true,
        userId: userID,
        shopId: [shopID],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: {
            [objectData.Id]: {
                designation: objectData[t("Designation")],
                tag: objectData.tag,
                isArchived: false,
                support_de_vente: salesSupport.join(","),
                shopId: shopID,
                urlImage: objectData.Image,
                isActive: objectData.isActive,
                img: objectData.img,
            },
        },
    };

    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    const requestOptions = {
        method: "POST",
        body: data,
    };
    try {
        const data: any = await fetchGlobal(apiUrlAdd, requestOptions);
        if (data.error) {
            throw Error("error");
        }
        ShowSuccessToast(`${t("logo is successfully added")!}`);

        setDataIsUpdated(true);
        setIsDataUpdatedShops(true);
        setIsValidateClicked(true);
        setLogoData({});
        resetAllPeripherals();
        setDesignation("");
        setSalesSupport([]);
        setUploadedImage("");
        setNumberActive(numberActive + 1);
        setLocalFilterActive(false);
        clearData();
        clearMultiCustomSelectionData();
    } catch (e) {
        ErrorToast(`${e}`);
    }
}

export async function confirmationActiveLogo(
    isValidation: boolean,
    selectedRows: any,
    ArchivedLogo: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: any
) {
    setIsLoading(true);
    setIsValidateClicked(false);
    const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
    let data1: any = {};
    let shopIds: any = [];
    Object.values(selectedRows).forEach(async (element: any) => {
        const id = element.Id;
        let shopsArchived = isValidation ? ArchivedLogo(element) : ["0"];
        shopsArchived.forEach((el: any) => {
            if (!shopIds.includes(el)) {
                shopIds.push(el);
            }
            data1[id] = {
                designation: element[t("Designation")],
                support_de_vente: element[t("Sales support")],
                urlImage: element[t("Image")],
                shopId: el,
                tag: element.tag,
                img: element.img,
                isActive: el === "0" ? true : false,
                isArchived: false,
            };
        });
    });
    let dataLogo = {
        userId: userID,
        shopId: shopIds,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        data: data1,
    };
    const data = new FormData();
    data.append("dataLogo", JSON.stringify(dataLogo));
    data.append("image", "");
    const requestOptions = {
        method: "POST",
        body: data,
    };

    try {
        const result: any = await fetchGlobal(apiUrlAdd, requestOptions);

        if (!result.error) {
            ShowSuccessToast(`${t("logo has been successfully activated")!}`);
            setIsLoading(false);
            setDataIsUpdated!(true);
            setIsValidateClicked(true);
            setKey(uuid());
        } else {
            throw Error(result.message);
        }
    } catch (e) {
        ErrorToast(`${e}`);
        setIsLoading(false);
    }
}

export async function editLogoV2(
    dataAssociate: any,
    isValidateButtonDisabled: boolean,
    setIsValidateButtonDisabled: any,
    rowData: any,
    oneShop: any,
    uploadedImage: any,
    userID: any,
    shopId: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    designation: any,
    dataState: any,
    salesSupport: any,
    img: any,
    i18nextLng: any,
    setIsAddLogoClicked: any,
    isAddLogoClicked: any,
    resetAllPeripherals: any,
    setSalesSupport: any,
    setInputImage: any,
    editedDataLogo: any,
    fetchGlobal: any
) {
    dataAssociate.push(rowData);
    let objectData = {};
    let shopIds: any = [];
    let updatedData: any = {};
    if (isValidateButtonDisabled === false) {
        setIsValidateButtonDisabled(true);
        setIsValidateClicked(false);
        setIsEdited(false);

        let urlImage = oneShop ? rowData.Image : uploadedImage;
        dataAssociate.forEach(async (el: any) => {
            if (!shopId.includes(el.shopId)) {
                shopIds.push(el.shopId);
            }

            Object.assign(objectData, {
                [el.Id]: {
                    designation: designation,
                    tag: el.tag,
                    isArchived: el.isArchived,
                    isActive:
                        Object.keys(dataState).length === 0
                            ? el.isActive
                            : el.Id === dataState.id
                            ? dataState.state
                            : el.isActive,
                    shopId: el.shopId,
                    urlImage: urlImage,
                    support_de_vente: salesSupport,
                    img: oneShop ? rowData.img : img,
                },
            });
        });

        let oldData = {
            designation: rowData[t("Designation")],
            support_de_vente: rowData[t("Sales support")],
            urlImage: rowData.Image,
        };
        if (rowData[t("Sales support")].includes("KIOSK") === true) {
            updatedData = getSalesSupportUpdated(
                oldData,
                {
                    designation: designation,
                    support_de_vente: salesSupport,
                    urlImage: urlImage,
                },
                "KIOSK",
                "support_de_vente"
            );
        }

        let dataLogo = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: objectData,
        };

        setEditedDataLogo(dataLogo);
        const formData = new FormData();
        formData.append(
            "dataLogo",
            JSON.stringify({
                dataLogo,
                updatedData,
            })
        );
        if (!oneShop) {
            if (uploadedImage) {
                formData.append("image", uploadedImage);
            }
        } else {
            formData.append("image", "");
        }
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/logo`;
        const requestOptions = {
            method: "POST",
            headers: {
                "Accept-Language": i18nextLng,
            },
            body: formData,
        };
        try {
            const data: any = await fetchGlobal(apiUrlAdd, requestOptions);
            if (data.error) {
                throw Error("error");
            }
            // if (!oneShop) {
            //     dataAssociate = AssociateLogo();
            // }
            setDataIsUpdated!(true);
            ShowSuccessToast(
                !(dataAssociate.length > 0)
                    ? `${t("The logo is changed successfully")!}`
                    : `${t(
                          "The logo of the franchise is changed successfully"
                      )!}`
            );

            // if (dataAssociate.length > 0) {

            // } else {
            setIsAddLogoClicked(!isAddLogoClicked);
            setIsValidateClicked(true);
            resetAllPeripherals();
            // setIsDataUpdatedShops(true);
            setSalesSupport([]);
            clearData();
            clearMultiCustomSelectionData();
            setInputImage(false);
            setInputImageUploader(false);
            // }
            setIsValidateButtonDisabled(false);
        } catch (e) {
            setIsAddLogoClicked(!isAddLogoClicked);
            setIsValidateClicked(true);
            throw e;
        }
    }
}

export function archiveLogoFranchise(archivedLogoFranchise: any) {
    const data =
        archivedLogoFranchise?.othersData?.dataFranchiseArchive.data ?? [];
    return extractUniqueIds(data);
}
